import { getLocations } from "components/task-list/lib/taskData";
import { useQuery } from "react-query";

export const useLocations = () => {
    return useQuery({
        queryKey: ["locations"],
        // initialData: [],
        queryFn: () => getLocations(),
    });
};
